export default __webpack_public_path__ + "static/media/21.8cbca4d0.pdf";